<div class="feedback-wrapper font-s-semibold" [ngClass]="type">
  @if (type !== 'custom') {
    <accredible-icon [icon]="iconClass" />

    <div [innerHTML]="message"></div>
  } @else {
    <ng-content />
  }
</div>
